import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split',
})
export class SplitPipe implements PipeTransform {
  transform(
    text: string,
    by: string,
    isRegex: boolean = false,
    index?: number
  ) {
    const arr = !isRegex ? text.split(by) : text.split(new RegExp(by)); // split text by "by" parameter
    return index ? arr[index] : arr.join(' '); // after splitting to array return wanted index
  }
}
